declare namespace $ {

	type $shm_agent_message_chart__option_shm_agent_message_text_1 = $mol_type_enforce<
		ReturnType< $shm_agent_message_text['chart_option'] >
		,
		ReturnType< $shm_agent_message_chart['option'] >
	>
	type $shm_agent_message_chart__height_shm_agent_message_text_2 = $mol_type_enforce<
		ReturnType< $shm_agent_message_text['chart_height'] >
		,
		ReturnType< $shm_agent_message_chart['height'] >
	>
	type $mol_view__sub_shm_agent_message_text_3 = $mol_type_enforce<
		ReturnType< $shm_agent_message_text['chart_invalid_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_message_text_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_agent_message_text extends $mol_text {
		link_click( next?: any ): any
		chart_option( id: any): any
		chart_height( id: any): number
		chart_invalid_rows( id: any): readonly(any)[]
		chart_error( id: any): string
		embeds_allowed( ): boolean
		file_open( id: any, next?: any ): any
		event( ): ({ 
			click( next?: ReturnType< $shm_agent_message_text['link_click'] > ): ReturnType< $shm_agent_message_text['link_click'] >,
		})  & ReturnType< $mol_text['event'] >
		Chart( id: any): $shm_agent_message_chart
		Chart_invalid( id: any): $mol_view
		Chart_error( id: any): $mol_view
	}
	
	export class $shm_agent_message_text_list extends $shm_markdown_text_list {
		indexes( ): readonly(number)[]
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map